export default __webpack_public_path__ + "static/media/gb.e607ea80.svg";